module.exports = __webpack_public_path__ + "static/media/Bangkok-florian-wehde.83e454bd.jpg";